import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { useDownloadBookMonthlyReportQuery } from "@modules/downloadBooks/queries";
import { DownloadBook } from "@modules/downloadBooks/types";

export function useDownloadBookList() {
  const { getQueryParams } = useQueryParams();
  const filters = getQueryParams();

  const { rows, loading, refetch, rowCount, ...tableProps } = usePaginatedTable<DownloadBook>({
    resource: "v1/download_book_admin",
    filters,
    sorters: { ordering: "-created_at" },
  });

  const { data: monthlyReport, isLoading: isLoadingReport } = useDownloadBookMonthlyReportQuery(filters);

  return {
    rows,
    loading,
    rowCount,
    tableProps,
    monthlyReport,
    isLoadingReport,
    refetch,
  };
}
